/* created by Athukorala */

import * as actionTypes from "./actionTypes";

export const browserHistoryHandler = (data) => {

  return {
    type: actionTypes.BROUSER_HISTORY,
    value: data
  }
};

